export default __webpack_public_path__ + "static/media/maximum_bet_50$.060e5129.mp3";